<template>
    <UserTabs
        :selected-user="selectedUser"
        :personal-team="userPersonalTeam"
        tab-key="user-activity-logs"
    >
        <ActivityLogRangePanel
            :title="`${selectedUser.name} — ${t('vue.kiosk_activity_logs')}`"
            :description="t('vue.kiosk_activity_logs_user_description')"
            :from="from"
            :to="to"
            :page="page"
            :per-page="perPage"
            :total="total"
            :logs="logs"
            :filters="filters"
            :filter-options="filterOptions"
            route-name="kiosk.users.activity-logs.index"
            :route-params="{ user: selectedUser.id }"
        />
    </UserTabs>
</template>

<script lang="ts" setup>
import type ICurrentTeam from "@/types/Members/ICurrentTeam";
import type IUser from "@/types/Members/IUser";
import { useTranslations } from "@/composables/useTranslations";
import ActivityLogRangePanel from "../../ActivityLogs/components/ActivityLogRangePanel.vue";
import type {
    IActivityLogFilterOptions,
    IActivityLogFilters,
    IActivityLogItem,
} from "../../ActivityLogs/types";

defineProps<{
    selectedUser: IUser;
    userPersonalTeam: ICurrentTeam;
    from: string;
    to: string;
    page: number;
    perPage: number;
    total: number;
    logs: IActivityLogItem[];
    filters: IActivityLogFilters;
    filterOptions: IActivityLogFilterOptions;
}>();

const { t } = useTranslations();
</script>
